import QuoteLink from './QuoteLink';

export default QuoteLink;
